import { useEffect, useRef, useState } from 'react';
import { getUser } from '../auth';
import { getOfflineOperations, subscribeOfflineQueue, syncOfflineOperations } from '../offlineQueue';

function OfflineQueueManager() {
  const [items, setItems] = useState(() => getOfflineOperations());
  const syncingRef = useRef(false);
  const user = getUser();

  const pendingCount = items.filter((item) => item.status === 'pending').length;

  const runSync = async () => {
    if (!user || syncingRef.current) return;
    if (typeof navigator !== 'undefined' && !navigator.onLine) return;
    if (getOfflineOperations().length === 0) return;

    try {
      syncingRef.current = true;
      await syncOfflineOperations();
      setItems(getOfflineOperations());
    } finally {
      syncingRef.current = false;
    }
  };

  useEffect(() => {
    const unsubscribe = subscribeOfflineQueue(setItems);
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!user) return;

    const onlineHandler = () => runSync();
    window.addEventListener('online', onlineHandler);

    const interval = setInterval(runSync, 60000);
    runSync();

    return () => {
      window.removeEventListener('online', onlineHandler);
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  useEffect(() => {
    if (!pendingCount) return;
    const timer = setTimeout(runSync, 1500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingCount]);

  return null;
}

export default OfflineQueueManager;
